var trackingHandler = require('src/interlock/no-ui/tracking/handler');
var trackingConst = require('src/interlock/no-ui/tracking/constant');

var Helper = require('./helper');
var $ = require('jquery');

var DELEGATION_SELECTOR = '[' + trackingConst.DATA_TRACKING_ID_ATTRIBUTE + ']';

/**
 *
 * @param event
 */
function engagementHandler(event) {
    var $currentEl = $(this);
    var $targetEl = $(event.target);
    /**
     * For the cases when data-tracking-id element has more than one target and for second one
     * we have false clicked target (issue can be seen on srp page clicking filters)
     */
    if ((Helper.isControlElement($targetEl) && event.type === 'click')
        || $currentEl.data('trackingDisabled')) {
        return;
    }

    var trackingId = $currentEl.data('tracking-id');
    var noRefresh = $currentEl.data('no-refresh');
    var trackingValue = $currentEl.data('tracking-value') || Helper.getActionValue($targetEl);

    var options = {
        currentEl: $currentEl,
        targetEl: $targetEl
    };

    trackingHandler.fireEvent(trackingId, {
        'ads': {
            'disable_refresh': Helper.isAdsRefreshDisabled($targetEl, noRefresh)
        },
        'event_data': {
            'value': trackingValue,
            'action_cause': Helper.getActionCause($targetEl),
            'creative_id': Helper.getElementCreativeId($targetEl)
        }
    }, options);
}

$(window.document).on('click change submit', DELEGATION_SELECTOR, engagementHandler);

/**
 * For unit testing purposes
 * @type {{}}
 */
module.exports = {
    engagementHandler: engagementHandler
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/element-engagement-handler/element-engagement-handler.js
// module id = 433
// module chunks = 36